<template>
  <div class="main-container">
    <!-- 二级路由导航 -->
    <div class="second-router-link" v-if="typeof secondRoutes !== 'undefined' && searchRootRoute.length > 0">
      <nav-item v-for="route in secondRoutes" :key="route.id" :item="route" :base-path="parent.path"></nav-item>
    </div>
    <!-- 二级路由视图 -->
    <div class="second-router-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import NavItem from './navBar/NavItem'
  export default {
    name: 'AppMain',
    components: {
      NavItem
    },
    computed: {
      ...mapGetters([
        'addRouters'
      ])
    },
    data() {
      return {
        secondRoutes: [],
        parent: {}
      }
    },
    watch: {
      $route(to, from) {
        this.generatorSecondRoutes()
      }
    },
    created() {
      this.generatorSecondRoutes()
    },
    methods: {
      getParentRoute: function() {
        const currRoute = this.$route.matched.length === 1 ? this.$route.matched[0] : this.$route.matched.filter(route => route.path === this.$route.path)[0]
        const parent = currRoute.parent
        if (typeof parent !== 'undefined' && parent != null) {
          return this.searchRootRoute(parent.path)
        }
        return null
      },
      // 查找一级路由
      searchRootRoute: function(path) {
        return this.addRouters.filter(route => route.path === path)[0]
      },

      generatorSecondRoutes: function() {
        const parent = this.getParentRoute()
        if (typeof parent !== 'undefined' && parent !== null && parent.group === 5) {
          this.secondRoutes = parent.children
          this.parent = parent
        } else {
          this.secondRoutes = []
        }
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .main-container {
    padding-left: 8%;
    padding-right: 8%;
    background-color: #f4f8f9;
    min-height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;

    .second-router-link {
      height: 40px;
      display: flex;
      align-items: flex-end;
    }
    .second-router-view {
      display: flex;
      flex-grow: 1;
    }
  }
</style>